<template>
  <div id="page-client-map-create">
    <client-map-form
        v-model="model"
        :loading="loading"
        ref="form"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              @click="$router.push({ name: 'client-map.list' })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              @click="create()"
              class="my-4"
              color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NotificationMixin from "@/components/mixins/NotificationMixin";
import ClientMapForm from "@/views/pages/client-map/ClientMapForm";
import SaveModelMixin from "../../../components/mixins/SaveModelMixin";

export default {
  name: "ClientMapCreate",
  components: {
    ClientMapForm
  },
  mixins: [NotificationMixin, SaveModelMixin],
  data() {
    return {
      model: {},
      references: [
        'CompanyProducer_FK',
        'Product_FK',
      ],
      loading: false,
    };
  },
  methods: {
    async create() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();

      //  return;
      try {
        const { data } = await this.$api.clientMap.create(params);
        this.notifySuccess('Client Map created');
        this.$router.back();
      } catch (e) {
        this.notifyError('Client Map failed to be created');
        console.error(e)
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>

</style>
